import React from 'react';
import { Row, Col } from 'react-bootstrap';

import BasicInfo from './BasicInfo.jsx';
import FieldTextArea from './FieldTextArea.jsx';
import FieldRatingSelfSubmit from './FieldRatingSelfSubmit.jsx';
import FieldTextAreaWithRating from './FieldTextAreaWithRating.jsx';

const overrideOptions = [
  { slug: 1, value: '1 - Poor' },
  { slug: 2, value: '2 - Below Average' },
  { slug: 3, value: '3 - Average' },
  { slug: 4, value: '4 - Above Average' },
  { slug: 5, value: '5 - Exceptional' },
];

export default function Reflection() {
  const fields = {
    mistakes: {
      label: 'Mistakes',
      description: 'What mistakes were made as a driver?',
      field: 'mistakes',
    },
    positive: {
      label: 'Positive',
      description: 'What were the positive moments as a driver?',
      field: 'positive',
    },
    ratings: [
      {
        label: 'Self-Preparation',
        description: 'Your preparation for race: film, notes, shop time, etc.',
        field: 'selfPreparation',
      },
      {
        label: 'Team-Preparation',
        description: 'Team\'s preparation for race: organization, planning, etc.',
        field: 'teamPreparation',
      },
      {
        label: 'Overall Vehicle Preparation',
        description: 'Overall vehicle preparation: adjustments, issues, etc.',
        field: 'carPreparation',
      },
      {
        label: 'Vehicle Interior',
        description: 'Vehicle\'s interior: belts, gauges, mirrors, pedals, seats, etc.',
        field: 'carInterior',
      },
      {
        label: 'Team Emotional Support',
        description: 'How team was emotionally supportive: listening, positivity, etc.',
        field: 'emotionalSupport',
      },
      {
        label: 'Team Adversity',
        description: 'Teams handling of adversity: attitude, composure, etc.',
        field: 'teamAdversityHandling',
      },
      {
        label: 'Crew Chief',
        description: 'Crew chief and their changes from practice to race',
        field: 'crewChiefEvaluation',
      },
      {
        label: 'Spotter',
        description: 'Spotter and their information given throughout race',
        field: 'spotterEvaluation',
      },
      {
        label: 'Driver Development',
        description: 'How team helped your driver development: feedback, instruction, etc.',
        field: 'driverDevelopment',
      },
      {
        label: 'Overall Team Evaluation',
        description: null,
        field: 'overallEvaluation',
      },
    ],
  };

  return (
    <form id="self-ratings-reflection-form" autoComplete="off">
      <h3>TRD Driver Self Rating - Reflection</h3>
      <BasicInfo />

      <div id="section-practice-details">
        <h4 className="rating-type">Reflection</h4>
        <p className="subtext">All information given is confidential and will not be shared with any group outside of TRD.</p>
        <Row>
          <Col xs={12}>
            <h6 className="pad">
              1) Goals
              <small>
                <br />(What were your goals for the race?)
              </small>
            </h6>
            <FieldTextArea
              field="goals"
              placeholder="Describe"
            />
          </Col>
          { [fields.mistakes, fields.positive].map((field, i) => (
            <Col sm={6} xs={12} key={`${i}.${field.field}`}>
              <h6 className="pad">
                { i + 2 }) {field.label}

                <small>
                  <br />({field.description})
                </small>
              </h6>
              <FieldTextArea
                field={field.field}
                placeholder="Describe"
              />
            </Col>
          )) }
        </Row>

        <h4></h4>

        <Row>
          { fields.ratings.map((question, i) => (
            <Col sm={6} xs={12} key={question.field}>
              <FieldTextAreaWithRating
                label={`${(i + 4)}) ${question.label}`}
                description={(question.description) ? `${question.description}` : null}
                ratingField={`${question.field}.rating`}
                textAreaField={`${question.field}.feedback`}
                placeholder="Describe"
                nonTrackRating={true}
                overrideOptions={overrideOptions}
                overrideDefaultValue={5}
              />
            </Col>
          )) }
        </Row>

        <div className="form-submit-wrapper">
          <div className="pull-right">
            <FieldRatingSelfSubmit formType="reflection" />
          </div>
        </div>
      </div>
    </form>
  );
}
